(function () {
  'use strict';
  angular.module('dtmService.module').factory('dataLayerService', ['$window', '$timeout', '$rootScope', 'uteLocale', 'dtmServiceConstants', '$filter', '$translate', '$q', function($window, $timeout, $rootScope, uteLocale, dtmServiceConstants, $filter, $translate, $q){
    var service = {};
    //var _trackData ; //TODO
    service.debug = $window._debug || true;
    service.dtmDataLayer = $window._trackData; //TODO

    /**
     * Check whether tracking DTM library loaded & _trackData function exists
     */
    service.is_trackDataFunctionExist = function(){
      if(typeof (_trackData) === 'function'){
        return true;
      }
      return false;
    };

    /**
     * Below function used to convert local time to EST time
     */
    service.calculateCurrentESTTime = function(){
      var offset = -4.0;
      if(!(moment().isDST())){ // if Daylight saving returns false ,then offset value will be -5
        offset = -5.0;
      }
      var clientDate = new Date();
      var utc = clientDate.getTime() + (clientDate.getTimezoneOffset() * 60000);
      return $filter('uteDateFormatter')(new Date(utc + (3600000*offset)), 'dddd|M/D/YYYY H:mm');
    };

    /**
     * Sent the payload information to _trackData()
     * if addBasicPayloadList param contains the lists of basic objects - to be merge
     */
    service.trackDataLayer = function(payloadInfo, isModalWindow, addBasicPayloadList, fromStateUrl, toStateUrl){
      if (!service.is_trackDataFunctionExist()) { //check _trackData function exists in DTM library
        return;
      }
      if(typeof addBasicPayloadList != 'undefined' && addBasicPayloadList != null && addBasicPayloadList.length > 0){
        payloadInfo = service.mergeBasicPayloadInfo(payloadInfo, isModalWindow, addBasicPayloadList, fromStateUrl, toStateUrl);
      }

      if (service.debug) {
        console.log(payloadInfo);
      }
      _trackData(payloadInfo);
      return;
    };

    service.trackErrors = function(payLoad, trackErrorsInfo, isModalWindow, addBasicPayloadList){
      if (!service.is_trackDataFunctionExist()) { //check _trackData function exists in DTM library
        return;
      }
      var errors = trackErrorsInfo;
      var errorPayload = {
        errors: errors,
        events: {
          error: true
        }
      };
      if(angular.isObject(payLoad)){  //payload exists then merge with error payload
        _.merge(payLoad, errorPayload);
      }
      service.trackDataLayer(payLoad, isModalWindow, addBasicPayloadList);
    };

    service.trackError = function(payLoad, errorType, errorCode, errorMessage, isModalWindow, addBasicPayloadList, errorCategory, errorAPI, errorField){
      if (!service.is_trackDataFunctionExist()) { //check _trackData function exists in DTM library
        return;
      }
      var errors = [] ;
      var _errorPayload = {
          type: errorType,
          code: errorCode,
          message: errorMessage,
          category: errorCategory
      };
      if(!_.isEmpty(errorAPI) && angular.isDefined(errorAPI)){
        _.merge(_errorPayload, {API : errorAPI});
      }
      if(!_.isEmpty(errorField)){
        _.merge(_errorPayload, {field : errorField});
      }
      errors.push(_errorPayload);
      service.trackErrors(payLoad, errors, isModalWindow, addBasicPayloadList);
    };

    service.trackServerSideError = function(payLoad, errorMessage, errorCode, apiUrl, errorType, isModal, basicPayloadList){
      if (!service.is_trackDataFunctionExist()) { //check _trackData function exists in DTM library
        return;
      }
      var errors = [] ;
      var isModalWindow = isModal ? isModal : false;
      var addBasicPayloadList = basicPayloadList ? basicPayloadList : dtmServiceConstants.dataLayerTrack.basicPayloadSections;
      var _errorPayload = {
        type: errorType ? errorType : dtmServiceConstants.dataLayerTrack.errorType.http,
        code: angular.isDefined(errorCode)? errorCode : '',
        message: errorMessage,
        category: dtmServiceConstants.dataLayerTrack.errorType.selfServeTransaction
      };
      if(!_.isEmpty(apiUrl) && angular.isDefined(apiUrl)){
        var apiName = apiUrl;
        if(apiUrl.indexOf('/') > -1){
          var apiNodeArray = apiUrl.split('/');
          apiName = apiNodeArray[apiNodeArray.length - 1];
        }
        _.merge(_errorPayload, {API : apiName});
      }
      errors.push(_errorPayload);
      service.trackErrors(payLoad, errors, isModalWindow, addBasicPayloadList);
    };

    service.trackApiError = function(response, analyticsInfo, isSuccess){
      if (!service.is_trackDataFunctionExist()) { //check _trackData function exists in DTM library
        return;
      }
      var deferred = $q.defer();

      try{
          var statusCode = response.status;
          var errors = [] ;
          var isModalWindow = false;
          var payLoad = {};
          var isEXceptionFound = false;
          var apiName = angular.isDefined(analyticsInfo.apiName) ? analyticsInfo.apiName : '';
          var pageViewBasicPayload = dtmServiceConstants.dataLayerTrack.basicPayloadInfo;
          var apiErrorTrack = _.find(dtmServiceConstants.dataLayerTrack.apiErrorTracking, function(apiErrorTracking) {
            return (apiErrorTracking.flow == (analyticsInfo && analyticsInfo.flowName)) ;
          });
          if(apiErrorTrack) {
            var errorKey = '';
            payLoad = {
              'page': apiErrorTrack.pageName
            };
            if(typeof apiErrorTrack[apiName] == 'object'){
              errorKey = apiErrorTrack[apiName].errorMessageKey;
              pageViewBasicPayload = (angular.isDefined(apiErrorTrack[apiName].pageView) && apiErrorTrack[apiName].pageView === true) ? dtmServiceConstants.dataLayerTrack.basicPayloadSections : pageViewBasicPayload;
            }else{
              errorKey = apiErrorTrack.errorMessageKey;
            }

            if(isSuccess){
              if(response && response.data && !_.isEmpty(response.data.error)){
                statusCode = response.error;
                isEXceptionFound = true;
              }
            }

            if(!isSuccess || (isSuccess && isEXceptionFound)){
              $translate(errorKey).then(function (translatedValues) {
                var _errorPayload = {
                  type: dtmServiceConstants.dataLayerTrack.errorType.http,
                  code: statusCode,
                  message: (response.status === 401 || response.status === 440) ? response.statusText : translatedValues,
                  category: dtmServiceConstants.dataLayerTrack.errorType.selfServeTransaction
                };
                if (!_.isEmpty(apiName) && angular.isDefined(apiName)) {
                  _.merge(_errorPayload, {API: apiName});
                }
                errors.push(_errorPayload);
                service.trackErrors(payLoad, errors, isModalWindow, pageViewBasicPayload);
              });
            }
          }
          deferred.resolve();
      }catch(e){
          deferred.reject(e);
      }
      return deferred.promise;
    };

    service.mergeBasicPayloadInfo = function(payload , isModalWindow, addBasicPayloadList, fromStateUrl, toStateUrl){

      _.each(addBasicPayloadList , function(list){
        switch (list){
          case dtmServiceConstants.dataLayerTrack.basicPayload.site:
            _.merge(payload, {site : service.getSiteInfo()});
            break;
          case dtmServiceConstants.dataLayerTrack.basicPayload.pageInfo:
            _.merge(payload, {page : service.getPageInfo(isModalWindow, fromStateUrl, toStateUrl)});
            break;
          case dtmServiceConstants.dataLayerTrack.basicPayload.pageView:
            _.merge(payload, {events: service.getEventInfo(dtmServiceConstants.dataLayerTrack.basicPayload.pageView)});
            break;
          case dtmServiceConstants.dataLayerTrack.basicPayload.interAction:
            _.merge(payload, {events: service.getEventInfo(dtmServiceConstants.dataLayerTrack.basicPayload.interAction)});
            break;
          case dtmServiceConstants.dataLayerTrack.basicPayload.account:
            if($rootScope.ruiMethods.user.is.loggedIn()) {
              _.merge(payload, {account: service.getAccountInfo()});
            }
            break;
          default:
        }
      });
      return payload;
    };

    service.getEventInfo = function(eventType){
      var events = {};
      switch (eventType){
        case dtmServiceConstants.dataLayerTrack.basicPayload.pageView:
          events = {
            pageView: true
          };
          break;
        case dtmServiceConstants.dataLayerTrack.basicPayload.interAction:
          events = {
            interaction: true
          };
          break;
        default:
      }
      return events;
    };

    service.getPageEventInfo = function(){
      var events = {
        pageView: true
      }
      return events;
    };

    service.getPageInfo = function(isModalWindow, fromStateUrl, toStateUrl){
      if(angular.isDefined(fromStateUrl) && angular.isDefined(toStateUrl) && !_.isEmpty(fromStateUrl) && !_.isEmpty(toStateUrl)){
        var pageObject ={
          language: uteLocale.language,
          province: uteLocale.province,
          url: isModalWindow ? 'modal popup' : toStateUrl,
          referrer: isModalWindow ? window.location.href : (fromStateUrl) ? fromStateUrl : document.referrer,
          ICMTimestamp: service.calculateCurrentESTTime(),
          responsiveVersion: $.restive.isMobile() ? dtmServiceConstants.dataLayerTrack.deviceType.mobile : dtmServiceConstants.dataLayerTrack.deviceType.desktop
        };
      }else{
        var pageObject ={
          language: uteLocale.language,
          province: uteLocale.province,
          url: isModalWindow ? 'modal popup' : window.location.href,
          referrer: isModalWindow ? window.location.href : ($rootScope.previousState && $rootScope.previousState.url) ? $rootScope.previousState.url : document.referrer,
          ICMTimestamp: service.calculateCurrentESTTime(),
          responsiveVersion: $.restive.isMobile() ? dtmServiceConstants.dataLayerTrack.deviceType.mobile : dtmServiceConstants.dataLayerTrack.deviceType.desktop
        };
      }
      return pageObject;
    };

    service.getSiteInfo = function(){
      var siteObject = {
        name: dtmServiceConstants.dataLayerTrack.siteName
      };
      return siteObject;
    };

    service.getAccountInfo = function(){
      var accountObject = {
         type: dtmServiceConstants.dataLayerTrack.account.type, //TODO
         userType: $rootScope.ruiMethods.user.is.agent() ? dtmServiceConstants.dataLayerTrack.userType.agent : dtmServiceConstants.dataLayerTrack.userType.consumer,
         userName: ($rootScope.userInfo && $rootScope.userInfo.userID) ? $rootScope.userInfo.userID : '',
         BAN: ($rootScope.userInfo && $rootScope.userInfo.selectedAccountNumber)? $rootScope.userInfo.selectedAccountNumber : '',
         CTN: ($rootScope.userInfo && $rootScope.userInfo.selectedSubscriberNo) ? $rootScope.userInfo.selectedSubscriberNo : '',
      };
      if($rootScope.ruiMethods.user.is.agent()){
        var agentInfo = {
          agentID:  $rootScope.ruiMethods.agent.repId(),
          dealerCode: $rootScope.ruiMethods.agent.storeCode(), //TODO
          agentType: $rootScope.ruiMethods.agent.type()
        };
        _.merge(accountObject,agentInfo);
      }
      return accountObject;
    };
    return service;
  }]);
})();


